import { AppInfo } from './../../app/credentials';

import { Component } from "@angular/core";
import { NavController, Platform, LoadingController, AlertController, App } from "ionic-angular";
import { Users } from "../../models/users";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { RegisterPage } from "../register/register";
import { AngularFireAuth } from "angularfire2/auth";
import { SubscriptionsPage } from "../subscriptions/subscriptions";
import { IUserSubData } from "../../models/userData";
import { FirebaseService } from "../../services/firebase.service";
import { Subscription } from "rxjs";
import { TabsPage } from "../tabs/tabs";

@Component({
  selector: "page-login",
  templateUrl: "login.html"
})
export class LoginPage {
  loading: any;

  myemail: string = "";
  userData: Users;
  autologin: boolean = false;
  ValidSubscription: boolean = false;
  UserSubscription: IUserSubData;

  validations_form: FormGroup;
  errorMessage: string = "";

  version: string;

  validation_messages = {
    email: [{ type: "required", message: "inserisci email" }, { type: "pattern", message: "indirizzo non valido" }],
    password: [{ type: "required", message: "Password is required." }, { type: "minlength", message: "Password must be at least 5 characters long." }],
    autologin: []
  };

  constructor(
    private navCtrl: NavController,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private afAuth: AngularFireAuth,
    private platform: Platform,
    private loadinCtrl: LoadingController,
    public alertCtrl: AlertController,
    private Firesrv: FirebaseService,
    public appCtrl: App,

  ) {}

  ionViewWillLoad() {
    this.ValidSubscription = false;
    this.version = AppInfo.Version

    this.validations_form = this.formBuilder.group({
      email: new FormControl("", Validators.compose([Validators.required, Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")])),
      password: new FormControl("", Validators.compose([Validators.minLength(1), Validators.required])),
      autologin: new FormControl("", Validators.compose([]))
    });

    this.platform.ready().then(() => {
      //verifica se ci sono le informazioni per il login automatico
      if (localStorage.getItem("UserDataLocal")) {
        this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));

     //   console.log("carico le informazioni di login dalla Local Storage");

        //compilo i campi della form con i dati letti dalla LocalStorage
        this.validations_form.controls["email"].setValue(this.userData.email);
        this.validations_form.controls["password"].setValue(this.userData.password);
        this.autologin = this.userData.autologin;
        this.validations_form.controls["autologin"].setValue(this.autologin, { onlySelf: true });

        //Verifico se devo eseguire l'accesso automatico
        if (this.userData.autologin) {
          this.tryLogin(this.userData);
        }
      }
    });
  }

  async tryLogin(value) {
    this.PresentLoading();

    /*
// Verirfico se posso eseguire il login con i dati locali
    if (localStorage.getItem("UserDataLocal")) {
      this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));

      // Verfico se la subscription è vailda
      let CurrentDate = new Date(Date.now());
      let endSubscription = new Date(this.userData.renewal_date);

      // Check if the dates are equal
      if (endSubscription >= CurrentDate) {
        console.log("current Date ->" + CurrentDate.toDateString());
        console.log("END Date ->" + endSubscription.toDateString());
        this.ValidSubscription = true;

        //avvio l'applicazione
        console.log ('accedo con la login locale')
        this.appCtrl.getRootNav().setRoot(TabsPage);

      } else {

        // La subscription è scaduta
        this.ValidSubscription = false;

      }



    };


*/



    this.authService.doLogin(value).then(
      res => {
        this.afAuth.authState.subscribe(user => {
          if (user) {
          //  console.log(user.email);
            this.Firesrv.SetUserDataAccess(user.email);
            if (user.emailVerified == true){

            this.ValidSubscription = false;
            // Verifica la subscription
            this._CheckSubscription(value, user).then(resolve =>{

              if (this.ValidSubscription) {
                //Salva le informazioni di login
                this.saveUserInfo(value, user, this.UserSubscription, this.ValidSubscription);

                //avvio l'applicazione
                // this.navCtrl.push(TabsPage, { Online: true });
                this.appCtrl.getRootNav().setRoot(TabsPage);
              } else {
                //Salva le informazioni di login
                this.saveUserInfo(value, user, null, this.ValidSubscription);

                // Apre la pagina delle subscription
                this.navCtrl.push(SubscriptionsPage, {});
              }

            });

            }else{

                console.log('Email non Verificata!');
              this.loading.dismiss();
              const confirm = this.alertCtrl.create({
                title: "Email non Verificata",
                message: "Per poter accedere è necessario verificare il prioprio indirizzo email. Controlla nella tua casella di posta",
                buttons: [
                  {
                    text: "Invia Nuovamente",
                    handler: () => {
                      console.log("Invio nuova mail");

                      this.SendConfermEmail();
                      this.AutologinChange();
                      const confirm = this.alertCtrl.create({
                        title: "Mail Iniviata",
                        message: "Ti abiamo inviato un email per confermare il tuo account",
                        buttons: [
                          {
                            text: "Ok",
                            handler: () => {
                              console.log("ok");
                            }
                          }
                        ]
                      });
                      confirm.present();
                    }
                  },
                  {
                    text: "Ok",
                    handler: () => {
                      console.log("ok");
                      this.AutologinChange();

                    }
                  },
                ]
              });
              confirm.present();

            }
          }




        });
      },
      err => {
        this.errorMessage = err.message;
        console.error(err.message);
        this.loading.dismiss();
      }
    );
  }

  _CheckSubscription(FormVaule, user): Promise<void> {
    return new Promise<void>(resolve => {
      //Verifico i dati di subscription
      let _someListener: Subscription = new Subscription();

      _someListener = this.authService.doSubscribe().subscribe((userSubData: IUserSubData[]) => {
        // Controllo che non sia il primo accesso.
        // Altrimenti crea una subscription di prova (7 giorni)

        // Disiscrivo l'observable
        _someListener.unsubscribe();

        if (userSubData.length > 0) {
          // Recupera una subscription valida
          this._GetSusbcritionValid(userSubData);

          resolve();
        } else {
          // Crea una subscription di prova
          this.userData = new Users();

          this.userData.id = user.uid;
          this.userData.email = FormVaule.email;
          this.userData.password = FormVaule.password;
          this.userData.autologin = this.autologin;
          this.userData.reg_date = user.metadata.creationTime;
          this.userData.period = "trial";


          // Calcola la data di scadenza della trial
          let CurrentDate = new Date(Date.now());
          CurrentDate.setDate(CurrentDate.getDate() + 7);

          // Setta la data
          this.userData.renewal_date = CurrentDate.toUTCString();
          this.userData.payment_date = new Date(Date.now()).toUTCString();
          this.userData.cost = "0";
          this.userData.active = true;

          // Creo una subscription di prova di 7 giorni
          this.Firesrv.SetUserData(this.userData);

          // Imposta la validità per consentire l'accesso
          this.ValidSubscription = true;

          resolve();
        }
      }); // fine subscribe
    }); // fine promise
  }

  _GetSusbcritionValid(userSubData: IUserSubData[]): Promise<void> {
    return new Promise<void>(resolve => {
    // Ciclo le subsciption per cercare quella valida
    userSubData.forEach((element: IUserSubData) => {
      let CurrentDate = new Date(Date.now());
      let endSubscription = new Date(element.renewal_date);



      // Check if the dates are equal
      if (endSubscription >= CurrentDate) {
        console.log("current Date ->" + CurrentDate.toDateString());
        console.log("END Date ->" + endSubscription.toDateString());
        this.ValidSubscription = true;
        this.UserSubscription = element;
      } // Controlla se la subscription e valida

      resolve();

    });
  });
}

  //Rimanda alla pagina di registrazione
  goRegisterPage() {
    this.autologin = false;
    this.validations_form.controls["autologin"].setValue(this.autologin, { onlySelf: true });
    this.navCtrl.push(RegisterPage);
  }


  //Imposta il selettore perv l'autologin
  AutologinChange() {
    this.autologin = !this.autologin;
    this.validations_form.controls["autologin"].setValue(this.autologin, { onlySelf: true });
  }

  /**
   * Salva le informazioni utenti nella local storage
   * @param cred Informazioni di login (email e password)
   * @param FireUserInfo Informazioni ricevute dalle API di firebase
   */
  saveUserInfo(cred, FireUserInfo, subscription: IUserSubData, actve: boolean) {
    this.userData = new Users();

    this.userData.id = FireUserInfo.uid;
    this.userData.email = cred.email;
    this.userData.password = cred.password;
    this.userData.autologin = this.autologin;
    this.userData.reg_date = FireUserInfo.metadata.creationTime;

    if (subscription) {
      this.userData.period = subscription.period;
      this.userData.payment_date = subscription.payment_date;
      this.userData.renewal_date = subscription.renewal_date;
      this.userData.cost = subscription.cost;
    }

    this.userData.active = actve;

    //Salvo nella local storage i dati dell'utente
    localStorage.setItem("UserDataLocal", JSON.stringify(this.userData));
    //console.log(this.userData);
  }

  //Reset della password
  resetPassword() {
    console.log("email di rest: " + this.myemail);
    this.authService.doResetPassword(this.myemail).then(
      res => {
        const confirm = this.alertCtrl.create({
          title: "Reimposta Password",
          message: "Ti abiamo inviato un link via email per procedere con il reset della password",
          buttons: [
            {
              text: "Ok",
              handler: () => {
                console.log("ok");
              }
            }
          ]
        });
        confirm.present();
      },
      err => {
        console.error(err.message);
        this.errorMessage = err.message;
      }
    );
  }


  //Reinvia la mail di verifica
  SendConfermEmail() {
    console.log("email di conf: " + this.myemail);
    this.authService.doSendEmailConferm().then(
      res => {
      console.log('email di verifica inviata');
      },
      err => {
        console.error(err.message);
        this.errorMessage = err.message;
      }
    );
  }


  //Mostra un alert perchè è scaduto l'abbonamento
  showConfirm() {
    const confirm = this.alertCtrl.create({
      title: "Spiacente...",
      message: "Ciao il tuo abbonamento risulta scaduto! Per continuare ad usare il servizio RINNOVALO ORA!",
      buttons: [
        {
          text: "Annulla",
          handler: () => {
            this.autologin = false;
            this.validations_form.controls["autologin"].setValue(this.autologin, { onlySelf: true });
            console.log("annulla");
          }
        },
        {
          text: "RINNOVA!",
          handler: () => {
            console.log("apre la pagina di rinnovo");
            window.open("https://www.fedecultura.com", "_system", "location=yes");
          }
        }
      ]
    });
    confirm.present();
  }

  //Mostra lo spin di caricamento
  async PresentLoading() {
    this.loading = await this.loadinCtrl.create({
      spinner: "ios",
      content: "Attendere...",
      dismissOnPageChange: true
    });
    await this.loading.present();
  }


  ShowPolicy(){
    const confirm = this.alertCtrl.create({
      title: "Termini e Privacy",
      message: "",
      buttons: [
        {
          text: "ACCETTO",
          handler: () => {

            console.log("ACCETTO");
          }
        },
      ]
    });
    confirm.present();
  }
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts